import { render, staticRenderFns } from "./NonCompliantProductAddProductFormComponent.vue?vue&type=template&id=b938700a&scoped=true"
import script from "./NonCompliantProductAddProductFormComponent.vue?vue&type=script&lang=js"
export * from "./NonCompliantProductAddProductFormComponent.vue?vue&type=script&lang=js"
import style0 from "./NonCompliantProductAddProductFormComponent.vue?vue&type=style&index=0&id=b938700a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b938700a",
  null
  
)

export default component.exports